function setSingleListValueIntoFilters (id, data) {
	$('#' + id + ' select').val(data)
}

function setListValueIntoFilters (id, dataArray) {
	var $area = $('#' + id)
	var $checkboxes = $area.find('.checkbox-list').find('input[type=\'checkbox\']').removeAttr('id').prop('checked', false)
	var valuesStr = ''
	_.each(dataArray, function (value, index) {
		var checkbox = _.find($checkboxes, function (element) {
			return $(element).val() === value
		})
		if (checkbox) {
			$(checkbox).prop('checked', true).attr('id', 'list__' + id + '__' + index).parent().addClass('active-item')
			valuesStr += $(checkbox).parent().text() + ','
		}
	})
	var maxCount = $area.attr('max-count')
	if (maxCount > -1 && _.size(dataArray) == maxCount) $area.addClass('restraint')
	if ($area.find('.checkbox-list input[type=\'checkbox\']:checked').length > 0) {
		$checkboxes.closest('.mcb-item-list').find('.mcb-clear').removeClass('blank')
	}
	$area.find('.value-list').text(valuesStr.length > 0 ? valuesStr.substring(0, valuesStr.length - 1) : '')
}

function setSingleDateValueIntoFilters (id, index, data) {
	$('#' + id).find('input').eq(index).val(data)
}

export function setSingleTextValueIntoFilters (id, data) {
	$('#' + id).find('input').val(data)
}

export function setMultipleTextValueIntoFilters (id, data) {
	$('#' + id).find('textarea').val(data.join('\n'))
}

function setItemStatusIntoFilters (id, data) {
	var $statusFilter = $('#' + id)
	_.each(data, function (value, key) {
		//TODO: add none support
		if (value == 'TRUE' || value == 'FALSE') {
			var $filterElement = $statusFilter.find('.status-filter-element[data-name=' + key + ']')
			var statusSelector = value == 'TRUE' ? '.complete-status' : '.draft-status'
			$filterElement.find(statusSelector).first().addClass('selected')
		}
	})
}

export function routerForInitializeDataIntoFilters (attributeType, attributeName, attributeData, isMultiple) {
	if (attributeType == 'S' || attributeType == 'SL' || attributeType == 'N') {
		if (!isMultiple) {
			setSingleTextValueIntoFilters(attributeName, attributeData['val'].toString())
		} else {
			setMultipleTextValueIntoFilters(attributeName, attributeData['val'])
		}
	}
	if (attributeType == 'L') {
		setListValueIntoFilters(attributeName, attributeData['val'])
	}
	if (attributeType == 'B' || attributeType == 'A') {
		if (!isMultiple) {
			setSingleListValueIntoFilters(attributeName, attributeData['val'].toString())
		} else {
			//code for multiple attribute initialize
		}
	}
	if (attributeType == 'D') {
		if (!isMultiple) {
			if (!_.isUndefined(attributeData['from'])) {
				setSingleDateValueIntoFilters(attributeName, 0, attributeData['from'].toString())
			}
			if (!_.isUndefined(attributeData['to'])) {
				setSingleDateValueIntoFilters(attributeName, 1, attributeData['to'].toString())
			}
		} else {
			//code for multiple attribute initialize
		}
	}
	if (attributeType == 'NM') {
		if (!isMultiple) {
			if (!_.isUndefined(attributeData['val'])) {
				setSingleTextValueIntoFilters(attributeName, attributeData['val'].toString())
			}
			if (!_.isUndefined(attributeData['mu'])) {
				setSingleListValueIntoFilters(attributeName, attributeData['mu'].toString())
			}
		} else {
			//code for multiple attribute initialize
		}
	}
	if (attributeType == 'status') {
		setItemStatusIntoFilters(attributeName, attributeData);
	}
}
